import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import {
  GENDER_OPTIONS,
  GENDER_QUESTION,
  SECTION_NUMBER,
} from '~/pages/anatomyV2/gender/libs/components/AnatomyV2Gender/constants'
import { AnatomyV2GenderStyles as S } from '~/pages/anatomyV2/gender/libs/components/AnatomyV2Gender/styles'
import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { eventLogger } from '~/shared/services/eventLogger'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomyV2Gender = ({ pageId, nextPagePath }: TPageProps) => {
  useMatchHeaderBackground()

  const { t } = useTranslation('anatomyV2')
  const [answer, setAnswer] = useState('')
  const { isAnswersDisabled, handleChange, setIsAnswersDisabled } =
    useDelayedContinue()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: GENDER_QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <SectionProgress currentSection={SECTION_NUMBER} pageId={pageId} />

        <S.Title>
          <Trans ns="anatomyV2" i18nKey="onboarding.gender.title" />
        </S.Title>

        <S.Options>
          {GENDER_OPTIONS.map(({ key, emoji, i18nKey }) => (
            <S.OptionButton
              key={key}
              type="button"
              $isSelected={answer === key}
              disabled={isAnswersDisabled}
              onClick={() => {
                setAnswer(key)
                eventLogger.logBiUserGender(key)
                handleChange(key, handleContinue)
                setIsAnswersDisabled(true)
              }}
            >
              <S.OptionEmoji>{emoji}</S.OptionEmoji>
              {t(i18nKey)}
            </S.OptionButton>
          ))}
        </S.Options>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default AnatomyV2Gender
